module.exports = __webpack_public_path__ + "static/img/homeTwo.67749ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/homeTwo.png
// module id = z8iT
// module chunks = 1